/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as ProtectedRoute } from "./ProtectedRoute";
export { default as GuestRoute } from "./GuestRoute";
